import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import A2b from "../assets/images/a2b.png";
import Elza from "../assets/images/elza.png";
import Freshair from "../assets/images/freshair.png";
import Light from "../assets/images/Light.png";
import Esign from "../assets/images/esign.png";
import Esign1 from "../assets/images/esign1.jpg";
import Esign2 from "../assets/images/esign2.jpg";
import P2o from "../assets/images/p2o.png";
import P3o from "../assets/images/p3o.png";
import P4o from "../assets/images/p4o.png";
import P5o from "../assets/images/p5o.png";
import DesignModal from "./DesignModal";
import Lightmain from "../assets/images/Lightmain.png";
import Esignmain from "../assets/images/Esignmain.png";

const Eyebrow = ({ children }) => {
  const commentText = "//";
  return (
    <div className="eyebrow" aria-hidden>
      <span>{commentText}</span> {children}
    </div>
  );
};

function PortfolioSection() {
  const { t } = useTranslation();
  const [selectedDesign, setSelectedDesign] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const projects = [
    {
        titleKey: "portfolio.projects.ventilation",
        tech: "React, HTML, SCSS",
        url: "https://www.freshaircare.nl/",
        image: Freshair,
        type: "website"
      },
    {
        titleKey: "portfolio.projects.aiPlanner",
        tech: "Figma",
        url: "#",
        image: Light,
        images: [Light, P2o, P3o, P4o, P5o],
        fullDesign: Lightmain,
        type: "design"
      },
    {
      titleKey: "portfolio.projects.fulfillment",
      tech: "React, HTML, SCSS",
      url: "https://a2b-fulfilment.nl/",
      image: A2b,
      type: "website"
    },
    {
      titleKey: "portfolio.projects.aiSignatures",
      tech: "Figma",
      url: "#",
      image: Esign,
      images: [Esign1, Esign2],
      fullDesign: Esignmain,
      type: "design"
    },
    {
        titleKey: "portfolio.projects.glass",
        tech: "React, HTML, SCSS",
        url: "https://elzaglas.nl/",
        image: Elza,
        type: "website"
      },
  ];

  const handleProjectClick = (project, e) => {
    if (project.type === "design") {
      e.preventDefault();
      setSelectedDesign(project);
      setIsModalOpen(true);
    }
    // For websites, let the default link behavior work
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedDesign(null);
  };

  return (
    <section id="portfolio" className="card portfolio">
      <div className="portfolio__header">
        <Eyebrow>{t('portfolio.eyebrow')}</Eyebrow>
        <h3 className="portfolio__title">{t('portfolio.title')}</h3>
      </div>

      <div className="portfolio__grid">
        {projects.map((project, idx) => (
          <a 
            key={idx} 
            href={project.url} 
            className={`project-tile ${project.type === 'design' ? 'project-tile--design' : ''}`}
            target={project.type === 'website' ? '_blank' : undefined}
            rel={project.type === 'website' ? 'noopener noreferrer' : undefined}
            onClick={(e) => handleProjectClick(project, e)}
          >
            <img src={project.image} alt={t(project.titleKey)} className="project-tile__img" />
            <span className="project-tile__badge">{project.tech}</span>
            <h4 className="project-tile__title">{t(project.titleKey)}</h4>
            {project.type === 'design' && (
              <div className="project-tile__overlay">
                <span className="project-tile__view-text">{t('portfolio.viewDesign')}</span>
              </div>
            )}
          </a>
        ))}
      </div>

      <DesignModal 
        isOpen={isModalOpen}
        onClose={closeModal}
        design={selectedDesign ? {...selectedDesign, title: t(selectedDesign.titleKey)} : null}
      />
    </section>
  );
}

export default PortfolioSection;
